export const I18N = {
  en: {
    ARTCILES: "Articles",
    Official: "Official",
    Manager: "Manager",
    "Legal Reprentative": "Legal Reprentative",
    "Organization roles": "Organization roles",
    "Blog roles": "Blog roles",
    "Editor-in-chief": "Editor-in-chief",
    CHIEF_EDITOR: "CHIEF EDITOR",
    AUTHOR: "AUTHOR",
    REDACTOR: "REDACTOR",
    LEGAL_REPRESENTATIVE: "LEGAL REPRESENTATIVE",
    MANAGER: "MANAGER",
    OFFICIAL: "OFFICIAL",
    SHAREHOLDER: "SHAREHOLDER",
    QUALITY_MANAGER: "QUALITY MANAGER",
    EXTERNAL: "EXTERNAL",
    Mandated: "Mandated",
    Not_Mandated: "Not Mandated",
    Details: "Details",
    Join: "Join",
    Replay: "Replay",
    Purchase: "Purchase",
    "Possible to review the training for max 15 days after the date of the live":
      "Possible to review the training for max 15 days after the date of the live",
    Webinar: "Webinar",
    "In progress": "In progress",
    "Certificate included approved by": "Certificate included approved by",
    "En Live": "Live",
    see_version: "See version",
    atText: "at",
    publishedOn: "Published on",
    reading: "Reading",
    noOptions: "no options",
    sharedWith: "share with",
    share: "Share",
    "En Replay": "En Replay",
    add: "Add",
    quote_text: "Insert quote text",
    quote_author: "Insert quote author",
    offfcourse_library: "oFFFcourse lib",
    replayExpired: "Replay expired",
    review: "Review",
    resume: "Resume",
    play: "Play",
    rejoin: "Rejoin",
    participate: "Participate",
    buy: "Buy",
    details: "Details",
    free: "Free",
    subscribed: "You are subscribed",
    subscribedPremium: "Premium subscriber",
    forTheMembers: "for the members",
    inReplay: "In Replay",
    liveNow: "live now",
    seen: "Already Seen",
    presential: "On the spot",
    hybrid: "Hybrid",
    inLive: "In live",
    dateFrom: "From",
    timeTo: "to",
    dateTo: "to",
    errorOccurred: "Error occurred",
    includedPremium: "Included in premium",
    soldOut: "Sold out",
    d: "d",
    h: "h",
    m: "m",
    s: "s",
    includedInSeason: "Included in season",
    includedInCycle: "Included in cycle",
    inPresential: "On the spot",
    live: "LIVE",
    replay: "REPLAY",
    hourAbr: "h",
    hours: "hours",
    minutes: "minutes",
    and: "and",
    trainings: "Trainings",
    ofCertifiedAttestations: "of certified attestations",
    season: "Season",
    essential: "Essential",
    cycle: "Cycle",
    congress: "Congress",
    soonLive: "Coming soon live",
    soonInPerson: "Coming soon in person",
    registerNow: "Register now",
    buyTraining: "Buy training",
    moreDetails: "More details",
    program: "Program",
    buyTheCycle: "Buy the cycle",
    buyTheSeason: "Buy the season",
    buyTheEssential: "Buy the essential",
    alreadyPremiumSubscribed: "You are a premium subscriber",
    premiumSubscription: "premium subscription",
    premiumDescription:
      "Live & Replay access to the entire OfffCourse library*",
    subscribeToPremium: "Subscribe to Premium",
    containsExclusiveEvents:
      "* Includes exclusively all oFFFcourse virtual courses",
    twelveMonthsCommitment: "For 12 months, with commitment",
    year: "year",
    month: "month",
    monthly: "Monthly",
    yearly: "Yearly",
    saveAmount: "save",
    buyCycle: "Buy {{definiteLabel}}",
  },
  fr: {
    ARTCILES: "Articles",
    Official: "Officiel",
    Manager: "Directeur",
    "Legal Reprentative": "Représentant légal",
    "Organization roles": "Rôles de l'organisation",
    "Blog roles": "Rôles du blog",
    "Editor-in-chief": "Éditeur en chef",
    CHIEF_EDITOR: "Rédacteur en chef",
    AUTHOR: "Auteur",
    REDACTOR: "Rédacteur",
    LEGAL_REPRESENTATIVE: "REPRÉSENTANT LÉGAL",
    MANAGER: "GÉRANT",
    OFFICIAL: "OFFICIEL",
    SHAREHOLDER: "ACTIONNAIRE",
    QUALITY_MANAGER: "RESPONSABLE QUALITÉ",
    EXTERNAL: "EXTERNE",
    Mandated: "Mandaté",
    Not_Mandated: "Non Mandaté",
    Details: "Détails",
    Join: "Rejoindre",
    Replay: "Rejouer",
    Purchase: "Acheter",
    "Possible to review the training for max 15 days after the date of the live":
      "Possible de revoir la formation pendant max 15 jours après la date du live",
    Webinar: "Webinar",
    "In progress": "En cours",
    "Certificate included approved by": "Attestation incluse agréé par",
    "En Live": "En Live",
    see_version: "Voir version",
    atText: "à",
    publishedOn: "Publié le",
    reading: "Lecture de",
    noOptions: "aucune options",
    sharedWith: "partager avec",
    share: "Partager",
    "En Replay": "En Replay",
    add: "Ajouter",
    quote_text: "Insérer le texte de la citation",
    quote_author: "Insérer l'auteur de la citation",
    write_here: "Écrire ici ...",
    customize: "Personnaliser",
    customize_dynamic_fields: "Personnalisez avec des champs dynamiques",
    quiz: "Questionnaire",
    save: "Enregistrer",
    offfcourse_library: "oFFFcourse lib",
    replayExpired: "Replay expiré",
    review: "Revoir",
    resume: "Reprendre",
    play: "Lecture",
    rejoin: "Rejoindre",
    participate: "Participer",
    buy: "Acheter",
    details: "Détails",
    free: "Gratuit",
    subscribed: "Vous êtes inscrit",
    subscribedPremium: "Abonné premium",
    forTheMembers: "pour les membres",
    inReplay: "En Replay",
    liveNow: "en live maintenant",
    seen: "Déja Vu",
    presential: "En Présentiel",
    hybrid: "Hybride",
    inLive: "En live",
    dateFrom: "Du",
    timeTo: "à",
    dateTo: "au",
    errorOccurred: "Une erreur est survenue",
    includedPremium: "Inclus premium",
    soldOut: "Sold out",
    d: "j",
    h: "h",
    m: "m",
    s: "s",
    includedInSeason: "Fait partie d'une saison",
    includedInCycle: "Fait partie d'un cycle",
    inPresential: "Sur place",
    live: "LIVE",
    replay: "REPLAY",
    hourAbr: "h",
    hours: "heures",
    minutes: "minutes",
    and: "et",
    trainings: "Formations",
    ofCertifiedAttestations: "d’attestations certifiées",
    season: "Saison",
    essential: "Essentiel",
    cycle: "Cycle",
    congress: "Congré",
    soonLive: "Prochainement en live",
    soonInPerson: "Prochainement en présentiel",
    registerNow: "S'inscrire maintenant",
    buyTraining: "Acheter la formation",
    moreDetails: "Plus de détails",
    program: "Programme",
    buyTheCycle: "Acheter le cycle",
    buyTheSeason: "Acheter la saison",
    buyTheEssential: "Acheter l'essentiel",
    alreadyPremiumSubscribed: "Vous êtes abonné premium",
    premiumSubscription: "Abonnement premium",
    premiumDescription:
      "Accès Live & Replay à toute la bibliothèque oFFFcourse*",
    subscribeToPremium: "S’abonner au premium",
    containsExclusiveEvents:
      "* Comprend exclusivement toutes les formations oFFFcourse en virtuel",
    twelveMonthsCommitment: "Pendant 12 mois, avec engagement",
    year: "an",
    month: "mois",
    monthly: "Mensuel",
    yearly: "Annuel",
    saveAmount: "économisez",
    buyCycle: "Acheter {{definiteLabel}}",
  },
  nl: {
    ARTCILES: "Artikelen",
    Official: "Officieel",
    Manager: "Manager",
    "Legal Reprentative": "Wettelijke vertegenwoordiger",
    "Organization roles": "organisatie rollen",
    "Blog roles": "blog rollen",
    "Editor-in-chief": "Hoofdredacteur",
    CHIEF_EDITOR: "Hoofdredacteur",
    AUTHOR: "Auteur",
    REDACTOR: "Redacteur",
    LEGAL_REPRESENTATIVE: "WETTELIJKE VERTEGENWOORDIGER",
    MANAGER: "MANAGER",
    OFFICIAL: "OFFICIEEL",
    SHAREHOLDER: "AANDEELHOUDER",
    QUALITY_MANAGER: "KWALITEITSMANAGER",
    EXTERNAL: "EXTERNE",
    Mandated: "gemandateerde",
    Not_Mandated: "niet Gemandateerde",
    Details: "Details",
    Join: "Meedoen",
    Replay: "Herhaling",
    Purchase: "Aankoop",
    "Possible to review the training for max 15 days after the date of the live":
      "Mogelijkheid om de training te bekijken tot 15 dagen vanaf de datum van de live",
    Webinar: "Webinar",
    "In progress": "Bezig",
    "Certificate included approved by":
      "Certificaat meegeleverd goedgekeurd door",
    "En Live": "Live",
    see_version: "Zie versie",
    atText: "bij",
    publishedOn: "Gepubliceerd op",
    reading: "Lezen",
    noOptions: "[no options]",
    sharedWith: "[share with]",
    share: "Delen",
    "En Replay": "En Replay",
    add: "Toevoegen",
    quote_text: "Citaattekst invoegen",
    quote_author: "Voeg de auteur van de bronvermelding in",
    write_here: "Schrijf hier ...",
    customize: "Aanpassen",
    customize_dynamic_fields: "Aanpassen met dynamische velden",
    quiz: "Quiz",
    save: "Opslaan",
    offfcourse_library: "oFFFcourse lib",
    replayExpired: "Replay verlopen",
    review: "Beoordeling",
    resume: "Resume",
    play: "Lezing",
    rejoin: "Doe mee",
    participate: "Deelnemen",
    buy: "Kopen",
    details: "Details",
    free: "Gratis",
    subscribed: "U bent geregistreerd",
    subscribedPremium: "Premium abonnee",
    forTheMembers: "voor leden",
    inReplay: "In Replay",
    liveNow: "Nu live",
    seen: "Al Gezien",
    presential: "In-persoon",
    hybrid: "Hybride",
    inLive: "Live",
    dateFrom: "Van",
    timeTo: "tot",
    dateTo: "tot",
    errorOccurred: "Er is een fout opgetreden",
    includedPremium: "Premium inclusief",
    soldOut: "Sold out",
    d: "d",
    h: "u",
    m: "m",
    s: "s",
    includedInSeason: "Maakt deel uit van een seizoen",
    includedInCycle: "Maakt deel uit van een cyclus",
    inPresential: "In-persoon",
    live: "LIVE",
    replay: "REPLAY",
    hourAbr: "u",
    hours: "uren",
    minutes: "minuten",
    and: "en",
    trainings: "Trainingen",
    ofCertifiedAttestations: "geaccrediteerde opleiding",
    season: "Seizoen",
    essential: "Essentieel",
    cycle: "Cyclus",
    congress: "Congres",
    soonLive: "Binnenkort live",
    soonInPerson: "Binnenkort in persoon",
    registerNow: "Registreer nu",
    buyTraining: "Koop training",
    moreDetails: "Meer details",
    program: "Programma",
    buyTheCycle: "Koop de cyclus",
    buyTheSeason: "Koop het seizoen",
    buyTheEssential: "Koop het essentiële",
    alreadyPremiumSubscribed: "U bent een premium abonnee",
    premiumSubscription: "Premium abonnement",
    premiumDescription:
      "Toegang tot de volledige oFFFcourse bibliotheek, Live & in Replay*",
    subscribeToPremium: "Abonneren op Premium",
    containsExclusiveEvents:
      "* Omvat exclusief alle virtuele cursussen van oFFFcourse",
    twelveMonthsCommitment: "Voor 12 maanden, met verbintenis",
    year: "jaar",
    month: "maand",
    monthly: "Maandelijks",
    yearly: "Jaarlijks",
    saveAmount: "bespaar",
    ofCertifiedAttestations: "geaccrediteerde opleiding",
    buyCycle: "Koop {{definiteLabel}}",
  },
};
